import { defineStore } from 'pinia';
import type { ErrorItem, FileDetail } from '@/components/Types';

export const useAppStore = defineStore('app', {
  state: () => ({
    drawer: true,
    loading: false,
    currentPage: 1,
    currentTrack: 0,
    openTrack: 0,
    openDestination: [],
    currentSearch: '',
    fileName: '',
    file: '',
    files: [] as FileDetail[],
    songs: [],
    serverRoot: '',
    alertItems: [] as ErrorItem[],
    alertCount: 0
  }),

  getters: {
    getAlertItems(): ErrorItem[] {
      return this.alertItems
    },
    fileLength(): number {
      return this.files.length;
    },
    getServerRoot(): string {
      console.log(window.location.origin)
      if (window.location.origin.includes('localhost')) {
        return 'http://192.168.86.11/pdf/';
      } else {
        return 'https://data.tdot.men/pdf/';
      }
    }
  },
  actions: {
    setSearch(term: string) {
      this.currentSearch = term
    },
    saveFiles(files: FileDetail[]) {
      this.files = files;
      this.saveSongs(files);
    },
    saveSongs(files: FileDetail[]) {
      const songlist = []
      for (const f of files) {
        for (const l of f.songs) {
          l.album = f.name
          l.url = f.url
          l.track = f.songs?.indexOf(l)
          songlist.push(l)
        }
      }
      this.songs = songlist;
    },
    setTrack(value: number) {
      this.currentTrack = value;
    },
    setPage(value: number) {
      this.currentPage = value;
    },
    resetFile() {
      this.fileName = "";
      this.file = "";
    },
    showIndexedOnly() {
      const results = this.files.filter(f => JSON.parse(JSON.stringify(f)).songs.length > 0);
      return results;
    },
    find(value: string) {
      const query = value.toLowerCase().replace(/\s+/g, '');
      const results = this.files.filter(f => (JSON.stringify(f).toLowerCase().replace(/\s+/g, '').includes(query)));

      return results;

    },
    findSong(value: string) {
      const query = value.toLowerCase();
      const results = this.songs.filter(f => f.title.toLowerCase().includes(query))
      return results;

    },

    setAlert(value: ErrorItem) {
      if(!value.message?.includes('getDocument'))
      {
        value.id = this.alertCount++
        value.time = new Date()
        this.alertItems.push(value)
      }
    }
  }
})
